/** Soft full-bleed pattern + orbs shared by all moteur heroes */
const HeroBackdrop = () => (
  <>
    <div className="absolute inset-0 bg-[var(--gradient-surface)]" />
    <div className="absolute inset-0 bg-[var(--gradient-glow)]" />
    <div className="absolute -right-16 -top-24 h-80 w-80 rounded-full bg-[color-mix(in_oklab,var(--primary)_16%,transparent)] blur-3xl nomad-search-hero__pulse" />
    <div className="absolute -bottom-24 left-[12%] h-72 w-72 rounded-full bg-[color-mix(in_oklab,var(--primary)_12%,transparent)] blur-3xl" />
    <div className="absolute right-[28%] top-[18%] h-40 w-40 rounded-full bg-[color-mix(in_oklab,var(--primary)_8%,transparent)] blur-2xl nomad-search-hero__float-slow" />
    <svg
      className="absolute inset-0 h-full w-full opacity-[0.09] text-[var(--primary)]"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <defs>
        <pattern id="nomad-hero-dots" width="28" height="28" patternUnits="userSpaceOnUse">
          <circle cx="1.5" cy="1.5" r="1.5" fill="currentColor" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#nomad-hero-dots)" />
    </svg>
  </>
)

export default HeroBackdrop
